import { Component, Input } from '@angular/core';
import { LocationModel } from '@kanzi-apes/kanzi-models';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-detail-header',
    templateUrl: './location-detail-header.component.html',
    styleUrls: ['./location-detail-header.component.scss'],
    standalone: false
})
export class LocationDetailHeaderComponent {
  @Input() Location: LocationModel | null;
  constructor() {
    this.Location = null;
  }
}
